import "../Cursadas.css"
import "../../MainFrame.css"

import Eactive from '../../../../assets/iconos/estrella.verde.svg'
import Eoff from '../../../../assets/iconos/estrella.vacia.svg'
import dots from '../../../../assets/iconos/3dots.svg'
import ProfilePic from '../../../../assets/iconos/usuario.png'
import graduado from '../../../../assets/iconos/graduado.svg'



export default function Modulos (props){

    
    setTimeout(() => {

    });


    return(
        <div className="cursadas-inicio-container">
            {
            props.courseInfo ? 
                <div className="frame">   
                <div className="course-header">
                    <div className="cursada-title">
                        <h2>
                                {props.courseInfo.title}
                        </h2>
                        {/* <img src={Eactive} alt="favstar" className='favicon setpointer'/> */}
                    </div>
                    <div className='setpointer course-teacher'>
                        {/* <img src={props.courseInfo.teacher.url_profile_pic || ProfilePic} alt="contact-picture" className='chatpic2'/> */}
                        <img src={graduado} className="course-icon" alt="" />
                        <h4>{props.courseInfo.teacher.name}</h4>
                    </div>
                </div>
                <div className='course-intro'>
                    <p dangerouslySetInnerHTML={{__html: props.courseInfo.description}} style={{fontSize:20}}></p>
                    <br /><br /><br />
                    <a href={props.courseInfo.url_program} target="_blank" className="green-btn">Descargar programa</a>
                </div>
            </div>
            :
            <></>
            }
        </ div>
    );
}